import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FixWithAiToastComponent } from './fix-with-ai-toast.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [FixWithAiToastComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule
  ],
  exports: [FixWithAiToastComponent]
})
export class FixWithAiToastModule { }
